import { MapPin } from "@phosphor-icons/react";

/**
 * Presentational From / To / Date inputs for the sticky flight bar.
 * Controlled by the parent — no side effects here beyond firing change handlers.
 */
export default function StickyFlightFields({
  origin,
  originMeta,
  originTouched,
  onOriginChange,
  destination,
  onDestinationChange,
  depart,
  onDepartChange,
  today,
}) {
  const originTitle = originMeta?.city
    ? `Pre-filled from your location: ${originMeta.city}${originMeta.country ? `, ${originMeta.country}` : ""}`
    : undefined;

  return (
    <>
      <label className="flex items-baseline gap-2 flex-1 min-w-[110px] max-w-[180px]">
        <span className="overline text-[10px] text-[#4A4742] hidden lg:inline">From</span>
        <input
          value={origin}
          onChange={(e) => onOriginChange(e.target.value.toUpperCase().slice(0, 3))}
          placeholder="IATA"
          maxLength={3}
          title={originTitle}
          className="w-full bg-transparent border-b border-[#1B3B36]/30 px-1 py-1 text-sm focus:outline-none focus:border-[#B4533C] font-mono uppercase tracking-wider text-[#1B3B36]"
          data-testid="sticky-origin-input"
        />
      </label>

      {originMeta?.city && !originTouched && (
        <span
          className="hidden xl:flex items-center gap-1 text-[10px] font-mono text-[#4A4742] shrink-0"
          title={originTitle}
          data-testid="origin-geo-hint"
        >
          <MapPin size={10} weight="fill" className="text-[#B4533C]" />
          <span className="uppercase tracking-wider">{originMeta.city}</span>
        </span>
      )}

      <label className="flex items-baseline gap-2 flex-1 min-w-[110px] max-w-[180px]">
        <span className="overline text-[10px] text-[#4A4742] hidden lg:inline">To</span>
        <input
          value={destination}
          onChange={(e) => onDestinationChange(e.target.value.toUpperCase().slice(0, 3))}
          placeholder="IATA"
          maxLength={3}
          className="w-full bg-transparent border-b border-[#1B3B36]/30 px-1 py-1 text-sm focus:outline-none focus:border-[#B4533C] font-mono uppercase tracking-wider text-[#1B3B36]"
          data-testid="sticky-dest-input"
        />
      </label>

      <label className="flex items-baseline gap-2">
        <span className="overline text-[10px] text-[#4A4742] hidden lg:inline">Depart</span>
        <input
          type="date"
          value={depart}
          min={today}
          onChange={(e) => onDepartChange(e.target.value)}
          className="bg-transparent border-b border-[#1B3B36]/30 px-1 py-1 text-sm focus:outline-none focus:border-[#B4533C] font-mono text-[#1B3B36]"
          data-testid="sticky-date-input"
        />
      </label>
    </>
  );
}
